// src/locales/en/header.js
export const header = {
    searchPlaceholder: "Search orders, products, customers...",
    search: "Search",
    notifications: "Notifications",
    markAllRead: "Mark all read",
    viewAllNotifications: "View all notifications",
    noNotifications: "No notifications",
    profileSettings: "Profile Settings",
    accountSettings: "Account Settings",
    businessSettings: "Business Settings",
    roleManagement: "Role Management",
    areYouSureLogout: "Are you sure you want to logout?",
    searchResults: "Search Results",
    searching: "Searching...",
    searchError: "Failed to search orders",
    noOrdersFound: "No orders found",
    searchHint: "Search by order number, phone number, or airwaybill number",
    viewAllResults: "View all results",
    mobileSearchHint: "Enter order number, phone number, or airwaybill number to search. Press enter to view results."
}